export default __webpack_public_path__ + "static/media/signet.3c9f2d91.svg";